export const enum PRODUCT_PERMISSIONS {
  CURRICULUM = 'curriculum',
  DISCUSSION = 'discussion',
  ROLEPLAY = 'roleplay',
  VOIP = 'voip',
  ANALYSIS = 'analysis',
}

export interface IAppPricingData {
  currency: string
  periodPrice: string
  platform: string
  productId: string
  eligibleFreeTrial: boolean
  offerType: string
  offerPeriodInDays: number
  offerPrice: number
  googleBasePlanId?: string
  googleOfferId?: string
  permissions?: any
}

export type AITutorPlan = {
  aiTutorPlanPricingId: string //id
  permissions: any // 제공하는 기능
  billingPeriodUnit: string // 플랜 결제 기간 확인 from server
  googleProductId: string // Google 결제 시 필요 from server
  googleBasePlanId: string // Google 결제 시 필요 from server
  googleOfferId: string | null // Google 결제 시 필요, offerId is optional since it's not present in all cases, from server
  appleProductId: string // 애플 결제 시 필요 from server
  name: string // 유저가 보는 이름 from server
  periodPrice: string // 서버에서 가져온 priceCurrencyJSON + 스토어 locale 정보 조합 from app
  monthlyPrice: number // periodPrice / 월 formatted in client
  originalPrice: number // 정가 from server & formatted with app
  monthlyOriginalPrice: number // originalPrice / 월 formatted in client
  isPopular: boolean // 인기? from client
  offerType: string
  offerPeriodInDays: number
  offerPrice: number
  currency: string // 결제 통화 from app
  platform: string // 현재 플랫폼
}

export const enum RECEIVED_MESSAGE_TYPES {
  APP_PRICING_DATA = 'appPricingData',
  IAP_PURCHASE_FAILED_SEND_TO_CHANNEL_TALK = 'IAP_PURCHASE_FAILED_SEND_TO_CHANNEL_TALK',
}

export const enum POST_MESSAGE_TYPES {
  IAP_PRODUCT_IDS = 'pass_on_product_ids',
  IAP_PURCHASE_SUBSCRIPTION_SUCCESS = 'iap_purchase_subscription_success',
}

export const IOS_ANNUAL_ALL_IN_ONE_PLAN_ID = 88 as const
export const AOS_ANNUAL_ALL_IN_ONE_PLAN_ID = 92 as const
